<template>
  <div class="app-container">
    <MainPage />
  </div>
</template>

<script>
import MainPage from "./pages/MainPage.vue";

export default {
  name: "App",
  components: {
    MainPage,
  },
  data() {
    return {
      lastWidth: 0,
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      const container = document.querySelector(".app-container");
      if (!container) return;

      const windowWidth = window.innerWidth;

      // 너비 변화가 없으면 리턴 (모바일 주소창 show/hide 대응)
      // 단, 최초 로드 시(lastWidth === 0)에는 실행되어야 함
      if (this.lastWidth !== 0 && windowWidth === this.lastWidth) {
        return;
      }
      this.lastWidth = windowWidth;

      const targetWidth = 412; // 412px 기준 레이아웃
      const minScalingWidth = 340; // 스케일링 적용 최소 너비

      // 340px ~ 412px 구간에서만 스케일링 적용
      if (windowWidth >= minScalingWidth && windowWidth < targetWidth) {
        const scale = windowWidth / targetWidth;
        container.style.width = `${targetWidth}px`;
        container.style.transform = `scale(${scale})`;
        container.style.transformOrigin = "top center";
      } else {
        // 스타일 초기화
        container.style.width = "";
        container.style.transform = "";
        container.style.transformOrigin = "";
      }
    },
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000;
  overflow-x: hidden;
  touch-action: pan-y;
}

/* 웹 환경 (데스크톱)에서만 최대 크기 적용 */

  .app-container {
    max-width: 500px; /* 웹일 때 최대 너비 */
    max-height: 869px; /* 웹일 때 최대 높이 */
  }


p {
  margin: 0;
}

@font-face {
  src: url(./assets/font/Roboto-Italic.ttf);
  font-family: "Roboto-Italic";
}
</style>
